import { Accommodation } from "@/components/Accommodation/Accommodation.tsx";
import { AccommodationSkeleton } from "@/components/AccommodationSkeleton/AccommodationSkeleton.tsx";
import { mergeRatePlans } from "@/helpers/mergeRatePlans.ts";
import { NoAccommodationsFound } from "@/pages/AccommodationPicking/components/NoAccommodationsFound/NoAccommodationsFound.tsx";
import { useClientSpecificSorting } from "@/pages/AccommodationPicking/components/RateGroupsList/hooks/useClientSpecificSorting.ts";
import { RateGroupsListProps } from "@/pages/AccommodationPicking/components/RateGroupsList/RateGroupsListProps.ts";

export const RateGroupsList = ({
  availableRateGroups,
  isLoading,
  handleOpenModal,
  showRateSwitcher,
}: RateGroupsListProps) => {
  const { sortRateGroups } = useClientSpecificSorting();

  if (isLoading) {
    return (
      <>
        <AccommodationSkeleton />
        <AccommodationSkeleton />
      </>
    );
  }
  if (availableRateGroups.length < 1 && !isLoading) {
    return <NoAccommodationsFound />;
  }

  const availableRGs = availableRateGroups.filter((rg) => mergeRatePlans(rg).some((rp) => rp.isAvailable));
  const unavailableRGs = availableRateGroups.filter((rg) => !mergeRatePlans(rg).some((rp) => rp.isAvailable));
  const sortedAvailableRGs = sortRateGroups(availableRGs);
  const sortedUnavailableRGs = sortRateGroups(unavailableRGs);

  return (
    <>
      {sortedAvailableRGs?.map((rg, index) => (
        <Accommodation
          key={rg.id}
          index={index}
          rateGroup={rg}
          handleOpenPreviewModal={handleOpenModal}
          showRateSwitcher={showRateSwitcher}
        />
      ))}

      {sortedUnavailableRGs.length > 0 &&
        sortedUnavailableRGs.map((rg) => (
          <Accommodation key={rg.id} rateGroup={rg} handleOpenPreviewModal={handleOpenModal} />
        ))}
    </>
  );
};
